export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9643.7c775f2f.jpg";